// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1nmEo","white":"Button_white__2HKEC","cyan":"Button_cyan__21in1"};